// 可继续支付
export var canPay = function canPay(order) {
  return order.pay_status === 'WAIT_PAY' && order.status === 'WAIT_PAY';
}; // 可用

export var canUse = function canUse(order) {
  return order.pay_status === 'PAYED' && (order.status === 'COMPLETE' || order.status === 'WAIT_USE' || order.status === 'PART_USE');
}; // 可退

export var canRefund = function canRefund(order) {
  return (order.pay_status === 'WAIT_PAY' || order.pay_status === 'PAYED') && (order.status === 'WAIT_PAY' || order.status === 'WAIT_USE' || order.status === 'WAIT_CONFIRM');
}; // 可改签

export var canChange = function canChange(order) {
  return order.tickets.every(function (ticket) {
    return ticket.ticket_type.type === 'BATCH' && ticket.status === 'WAIT_USE' && ticket.is_refund !== 0;
  }) && order.pay_status === 'PAYED';
};